import React, { FC } from 'react';
import { CenteredLoader } from '@wix/ai-scheduling-assistant-view-react';
import { Box } from '@wix/design-system';
import s from './ChatLoader.scss';

export const ChatLoader: FC = () => {
  return (
    <Box className={s.loaderContainer} height="100vh">
      <CenteredLoader />
    </Box>
  );
};
